import get from 'lodash/get';

import getProperties from './get-properties';

import type { Properties } from './get-properties';
import type { Path, PathValue } from 'convict';

export type PathParam = Path<Properties>;
export type GetReturn<K extends PathParam> = K extends null | undefined
  ? Properties
  : K extends Path<Properties>
    ? PathValue<Properties, K>
    : never;

export default {
  get<K extends PathParam>(path: K): GetReturn<K> {
    const properties = getProperties();
    return get(properties, path) as GetReturn<K>;
  },
};
